import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=3fd305ef&"
import script from "./RoleForm.vue?vue&type=script&lang=ts&"
export * from "./RoleForm.vue?vue&type=script&lang=ts&"
import style0 from "./RoleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports